import { authenType } from './types';

const signIn = (payload) => {
    return {
        type: authenType.REQUEST,
        payload
    }
}

const signOut = () => {
    return {
        type: authenType.SIGN_OUT_REQUEST,
    }
}

const updateProfile = (payload) => {
    return {
        type: authenType.UPDATE_PROFILE,
        payload
    }
}

const authenAction = {
    signIn,
    signOut,
    updateProfile
}

export default authenAction;